module.exports = __webpack_public_path__ + "static/media/caro_img_5.b8994549.webp";